import { render, staticRenderFns } from "./audio-recording.vue?vue&type=template&id=1981ec51&scoped=true&"
import script from "./audio-recording.vue?vue&type=script&lang=js&"
export * from "./audio-recording.vue?vue&type=script&lang=js&"
import style0 from "./audio-recording.vue?vue&type=style&index=0&id=1981ec51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1981ec51",
  null
  
)

component.options.__file = "audio-recording.vue"
export default component.exports